import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useBillingStatus } from '../hooks/useBilling.js';

export function RequireEntitlement({ children }: { children: ReactNode }) {
  const location = useLocation();
  const billing = useBillingStatus();

  if (billing.isLoading) {
    return (
      <div className="empty-state card" role="status" aria-live="polite">
        <p>Checking access…</p>
      </div>
    );
  }
  if (billing.isError || !billing.data) {
    return (
      <div className="empty-state card" role="alert">
        <h3>Couldn&apos;t verify your access</h3>
        <p>Check your connection and try again. Your data has not changed.</p>
        <button type="button" className="btn btn-primary" onClick={() => void billing.refetch()}>
          Retry
        </button>
      </div>
    );
  }
  if (billing.data.billingEnabled && billing.data.entitlement === 'locked') {
    return <Navigate to="/subscribe" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
